import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const SubjectSetupLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'SubjectSetup' */ './components/SubjectSetup')
);

export default (store) => {
	return {
		path: 'subject-setup/:campusId?',
		element: <AsyncLoading component={<SubjectSetupLazy />} />,
	};
};
